import AssignRouteTask from "./AssignRouteTask"

export default  AssignRouteTask;



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/RouteTaskTable/AssignRouteTask/index.js